import { fromJS } from 'immutable';

import {
  VIEW_ACTION_APPEND,
  VIEW_ACTION_REPLACE,
  VIEW_GET_LOADED,
} from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import {
  VIEW_RESET,
} from '../../../actions/Entity/View';

const initialState = fromJS({});

export default function view(state = initialState, action = {}) {
  switch (action.type) {
    // Cases from @uncinc/react-drupal-core
    case VIEW_GET_LOADED: {
      if (action.action === VIEW_ACTION_REPLACE) {
        return state.setIn([action.viewId, action.displayId], fromJS(action.data));
      } else if (action.action === VIEW_ACTION_APPEND) {
        return state.mergeDeepIn([action.viewId, action.displayId], fromJS(action.data));
      }

      return state;
    }

    // Custom Jellinek cases
    case VIEW_RESET: {
      return state.set(action.viewId, fromJS({}));
    }

    default:
      return state;
  }
}
